const Aecharts = a => require(['@/components/Aecharts'], a);

export default {
  name: 'AeRealLine',
  props: {
    // data: {
    //   type: Array,
    //   default: () => [
    //     { name: '栏目一', value: '20', color: '#2f7ed8' },
    //     { name: '栏目二', value: '60', color: '#1ed76d' },
    //     { name: '栏目三', value: '30', color: '#8bbc21' },
    //     { name: '栏目四', value: '50', color: '#910000' },
    //     { name: '栏目五', value: '80', color: '#1aadce' },
    //     { name: '栏目六', value: '10', color: '#492970' },
    //     { name: '栏目七', value: '15', color: '#f28f43' },
    //     { name: '栏目八', value: '25', color: '#77a1e5' },
    //   ]
    // },
    delay: { type: Number, default: () => 0 },
  },
  data() {
    return {
      data: [],
      option: null,
    }
  },
  created() {
    this.create();
  },
  methods: {
    format() {
      let now = new Date(1990, 9, 1);
      let day = 24 * 3600 * 1000;
      let value = Math.random() * 1000;
      now = new Date(+now + day);
      value = value + Math.random() * 21 - 10;
      let data = { name: now.toString(), value: [[now.getFullYear(), now.getMonth() + 1, now.getDate()].join('/'), Math.round(value)] };
      return data;
    },
    create() {
      for (let a = 0; a < 1000; a++) {
        this.data.push(this.format());
      }
      this.option = {
        title: {
          text: '动态数据 + 时间坐标轴'
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            params = params[0];
            var date = new Date(params.name);
            return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + ' : ' + params.value[1];
          },
          axisPointer: {
            animation: false
          }
        },
        xAxis: {
          type: 'time',
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          splitLine: {
            show: false
          }
        },
        series: [{
          name: '模拟数据',
          type: 'line',
          showSymbol: false,
          hoverAnimation: false,
          data: this.data
        }]
      }
      let interval = setInterval(() => {
        for (var i = 0; i < 5; i++) {
          this.data.shift();
          this.data.push(this.format());
        }
      }, 1000);
      clearInterval(interval);
      interval = null;
      // setTimeout(() => {
      //   clearInterval(interval);
      //   interval = null;
      // }, 1000);
    }
  },
  render() {
    return <Aecharts option={this.option} delay={this.delay} />
  }
}